import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { getErrorMessage } from '@teetsh/app/src/components/Editor/utils/getErrorMessage';

export function useAIErrorHandler(error: string | null) {
  const { notifyWarning } = useNotification();
  const { t } = useTranslation(['common']);

  useEffect(() => {
    if (error) {
      const message = getErrorMessage(error, t);
      if (message) {
        notifyWarning(message);
      }
    }
  }, [error]); // Only depend on error changing, not the functions
}
